module.exports = __webpack_public_path__ + "img/23ne.2757d6d4.svg";